const MoveHistory = ({ moves, aiName = 'AI' }) => {
  // Group moves into pairs (white, black)
  const movePairs = [];
  for (let i = 0; i < moves.length; i += 2) {
    movePairs.push({
      number: Math.floor(i / 2) + 1,
      white: moves[i],
      black: moves[i + 1] || ''
    });
  }

  // Get short AI name for display
  const shortAiName = aiName.length > 8 ? aiName.substring(0, 8) : aiName;

  return (
    <div className="w-80 bg-accent dark:bg-dark-accent border-r-3 border-border-heavy dark:border-dark-border-heavy h-full flex flex-col overflow-hidden">
      <div className="p-6 pb-0">
        <h2 className="text-background dark:text-dark-background font-bold text-lg mb-5 pb-3 border-b-2 border-background dark:border-dark-background">Move History</h2>
        
        {/* Legend */}
        <div className="flex items-center gap-4 py-2 px-4 mb-3 bg-background dark:bg-dark-background border-2 border-background dark:border-dark-background">
          <span className="text-text-tertiary dark:text-dark-text-tertiary w-8 font-mono text-xs font-bold">#</span>
          <span className="text-text-primary dark:text-dark-text-primary w-16 font-mono text-xs font-bold">You</span>
          <span className="text-text-secondary dark:text-dark-text-secondary w-16 font-mono text-xs font-bold">{shortAiName}</span>
        </div>
      </div>
      
      <div className="flex-1 overflow-y-auto px-6 pb-6">
        <div className="space-y-2">
        {movePairs.length === 0 ? (
          <p className="text-surface dark:text-dark-surface text-sm font-medium">No moves yet</p>
        ) : (
          movePairs.map((pair) => (
            <div key={pair.number} className="flex items-center gap-4 py-3 px-4 border-2 border-background dark:border-dark-background bg-background dark:bg-dark-background hover:bg-surface dark:hover:bg-dark-surface transition-all duration-150 font-mono text-sm">
              <span className="text-text-tertiary dark:text-dark-text-tertiary w-8 font-bold">{pair.number}.</span>
              <span className="text-text-primary dark:text-dark-text-primary w-16 font-medium">{pair.white}</span>
              <span className="text-text-secondary dark:text-dark-text-secondary w-16 font-medium">{pair.black}</span>
            </div>
          ))
        )}
        </div>
      </div>
    </div>
  );
};

export default MoveHistory;
